import { gql } from '@apollo/client';

export const EMAIL_CONFIRMATION_MUTATION = gql`
  mutation requestEmailConfirmation {
    requestEmailConfirmation
  }
`;

export const EMAIL_VERIFIED_QUERY = gql`
  query account {
    account: accountData {
      isEmailVerified
      isEmailVerificationRequired
    }
  }
`;
